export const getPageLink = (path, params) =>
  path.replace(/:([^/?]+)\??/g, (match, paramName) => params[paramName]);
